import { render, staticRenderFns } from "./InsuranceDashboard.vue?vue&type=template&id=544bbe5c&scoped=true"
import script from "./InsuranceDashboard.vue?vue&type=script&lang=ts"
export * from "./InsuranceDashboard.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceDashboard.vue?vue&type=style&index=0&id=544bbe5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544bbe5c",
  null
  
)

export default component.exports